import { Component } from '@angular/core';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';

import { UpdateWindowsClientComponent } from './update-windows-client/update-windows-client.component';
import { UpdateAndroidClientComponent } from './update-android-client/update-android-client.component';
import { AppConstants } from '../../../../app.constants';

@Component({
  selector: 'modal-update-client-file-path',
  standalone: true,
  imports: [
    MatTabsModule,
    UpdateWindowsClientComponent,
    UpdateAndroidClientComponent
  ],
  templateUrl: './modal-update-client-file-path.component.html',
  styleUrls: ['./modal-update-client-file-path.component.scss']
})
export class ModalUpdateClientFilePathComponent {
  selectedTabIndex: number = AppConstants.WINDOWS_UPDATE_CLIENT_TAB_INDEX;
}
